export const YOUR_CATEGORIES = 'your-categories'

export const YOUR_CATEGORIES_OPTION = {
  id: YOUR_CATEGORIES,
  value: YOUR_CATEGORIES,
  label: 'Your categories',
}
